export const RATE_MODE_DESCRIPTIONS = {
  LIVE: "Real-time market rates with automatic updates",
  ADMIN: "Manually managed rates by administrators",
  HYBRID: "Combination of market and manual rates",
};

export const POLICY_DESCRIPTIONS = {
  INHERIT: "Use rates from parent or main branch",
  CUSTOM: "Define branch-specific rates",
  HYBRID: "Mix of inherited and custom rates",
};

export const METAL_TYPES = {
  GOLD: 'gold',
  SILVER: 'silver',
  PLATINUM: 'platinum',
  DIAMOND: 'diamond',
};

export const SYNC_FREQUENCIES = {
  REALTIME: { label: "Real-time (Every 5 minutes)", value: "REALTIME" },
  HOURLY: { label: "Every Hour", value: "HOURLY" },
  DAILY: { label: "Once Daily", value: "DAILY" },
  MANUAL: { label: "Manual Only", value: "MANUAL" },
};
